<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    :close-on-click-modal="false"
    append-to-body
    @close="close"
  >
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
    >
      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          type="text"
          size="large"
          auto-complete="off"
          placeholder="账号"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          size="large"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter="handleLogin"
        >
        </el-input>
      </el-form-item>
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <el-form-item
          prop="code"
          v-if="captchaEnabled"
        >
          <el-input
            v-model="loginForm.code"
            size="large"
            auto-complete="off"
            placeholder="验证码"
            @keyup.enter="handleLogin"
          >
          </el-input>
          
        </el-form-item>
        <div class="login-code">
          <img
            :src="codeUrl"
            @click="getCode"
            class="login-code-img"
          />
        </div>
      </div>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="handleLogin"
        :loading="loading"
      >登 录</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { api } from '@/api/api'

export default {
  // components: {  },
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '750px'
    },
    modelType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      dialogVisible: false,
      currentComponent: '',
      loginForm: {
        username: null,
        password: null,
        code: null,
        uuid: null
      },
      captchaEnabled: true,
      codeUrl: '',
      loading: false,
      loginRules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
    }
  },
  mounted() {
  },
  methods: {
    show() {
      this.dialogVisible = true
      this.getCode()
      for(let key in this.loginForm) {
        this.loginForm[key] = null
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          const params = { 
            url: api.login, 
            data: {...this.loginForm} 
          }
          this.$http.post(params).then((res) => {
            if(res.data.code == 200) {
              let token = res.data.token
              localStorage.setItem('token', token)
              this.dialogVisible = false
              this.loading = false
              this.$message.success('登录成功')
            }else{
              this.loading = false
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
            this.loginForm.code = ''
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getCode() {
      let params = {
        url: api.getCode,
        headers: {
          isToken: false
        },
      }
      this.$http.get(params).then((res) => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.data.img;
          this.loginForm.uuid = res.data.uuid;
        }
      })
    },
    close() {
      this.$nextTick(() => {
        this.$refs['loginForm'].clearValidate()
      })
    }
  }
}
</script>

<style>
.el-dialog__header {
  background: #07203b !important;
}
.el-dialog__body {
  background: #07203b !important;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
.el-dialog__title {
  color: #fff !important;
}
.el-dialog__footer {
  background: #07203b !important;
}
.login-code {
  width: 160px;
}
.login-code-img{
  width: 100%;
}
</style>